"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleHighchartsCalculations = void 0;
const highcharts_1 = __importDefault(require("highcharts"));
const lodash_1 = __importDefault(require("lodash"));
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const LifecycleCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/highcharts/LifecycleCalculations");
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const LifecycleChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleChartSettingsJSONModel");
const LifecycleGranularityJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleGranularityJSONModel");
const getGranularityName = (granularity) => {
    switch (granularity) {
        case LifecycleGranularityJSONModel_1.Granularity.daily:
            return `Daily`;
        case LifecycleGranularityJSONModel_1.Granularity.weekly:
            return `Weekly`;
        case LifecycleGranularityJSONModel_1.Granularity.monthly:
            return `Monthly`;
    }
};
const optionsForClassic = (data, params) => {
    //chart
    const chart = {
        type: "column",
        zoomType: "x"
    };
    const granularity = getGranularityName(params.granularity);
    let title = "";
    switch (params.chartType) {
        case LifecycleChartSettingsJSONModel_1.ChartType.classicWithPercents:
            title = `${granularity} Lifecycle (Percent)`;
            break;
        case LifecycleChartSettingsJSONModel_1.ChartType.classicWithCounters:
            title = `${granularity} Lifecycle (Count)`;
            break;
    }
    const plotColumnOptions = {
        stacking: 'normal',
        minPointLength: 3,
        pointPadding: 0,
        groupPadding: 0,
    };
    const plotOptions = {
        column: plotColumnOptions
    };
    const isPercentView = params.chartType === LifecycleChartSettingsJSONModel_1.ChartType.classicWithPercents;
    const chartSeries = isPercentView ?
        LifecycleCalculations_1.LifecycleCalculations.calculateClassicSeriesWithPercents(data) :
        LifecycleCalculations_1.LifecycleCalculations.calculateClassicSeriesWithCounters(data);
    let xAxis = {};
    if (!lodash_1.default.isEmpty(chartSeries)) {
        const xAxisMinTickInterval = 24 * 60 * 60 * 1000; //1 day
        xAxis = {
            dateTimeLabelFormats: DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.xAxis.dateTimeLabelFormats,
            type: "datetime",
            minTickInterval: xAxisMinTickInterval,
        };
    }
    const yAxis = {
        labels: {
            formatter: isPercentView ? function () {
                return `${this.value}%`;
            } : undefined
        },
        minTickInterval: isPercentView ? undefined : 1,
        title: { text: null },
    };
    if (isPercentView) {
        yAxis.maxPadding = 0;
        yAxis.minPadding = 0;
    }
    const tooltip = {
        useHTML: false,
        formatter: function () {
            const dateCorrected = new Date(this.x);
            const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, dateCorrected.getTime());
            const symbol = "<span style='color:" + this.color + "'>\u25CF</span>";
            const name = this.series.name;
            if (isPercentView) {
                const value = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(this.point.y, 2);
                return `<small>${date}</small><br/>${symbol} ${name}: <b>${value}%</b>`;
            }
            else {
                const value = this.point.y;
                return `<small>${date}</small><br/>${symbol} ${name}: <b>${value}</b>`;
            }
        }
    };
    return {
        exporting: {
            filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title)
        },
        chart: chart,
        title: { text: title },
        plotOptions: plotOptions,
        xAxis: xAxis,
        yAxis: yAxis,
        series: chartSeries,
        tooltip: tooltip
    };
};
const optionsForOvertime = (data, params) => {
    //chart
    const chart = {
        type: "line",
        zoomType: "x"
    };
    //title
    const granularity = getGranularityName(params.granularity);
    const title = `${granularity} Lifecycle (Over Time)`;
    const chartSeries = LifecycleCalculations_1.LifecycleCalculations.calculateOvertimeSeries(data);
    let xAxis = {};
    if (!lodash_1.default.isEmpty(chartSeries)) {
        const xAxisMinTickInterval = 24 * 60 * 60 * 1000; //1 day
        xAxis = {
            dateTimeLabelFormats: DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.xAxis.dateTimeLabelFormats,
            type: "datetime",
            minTickInterval: xAxisMinTickInterval,
        };
    }
    const yAxis = {
        labels: {
            formatter: function () {
                //"{value, number, ::percent scale/0.01 .#}"
                return `${this.value}%`;
            }
        },
        title: { text: null },
        maxPadding: 0,
        minPadding: 0,
    };
    const tooltip = {
        useHTML: false,
        formatter: function () {
            const dateCorrected = new Date(this.x);
            const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, dateCorrected.getTime());
            const symbol = "<span style='color:" + this.color + "'>\u25CF</span>";
            const name = this.series.name;
            const value = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(this.point.y, 2);
            //"<small>{date}</small><br/>{symbol} {name}: <b>{value, number, ::percent scale/0.01 .##}</b>"
            return `<small>${date}</small><br/>${symbol} ${name}: <b>${value}%</b>`;
        }
    };
    return {
        exporting: {
            filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title)
        },
        chart: chart,
        title: { text: title },
        xAxis: xAxis,
        yAxis: yAxis,
        series: chartSeries,
        tooltip: tooltip
    };
};
const optionsForQuickRatio = (data, params) => {
    //chart
    const chart = {
        type: "line",
        zoomType: "x"
    };
    //title
    const granularity = getGranularityName(params.granularity);
    const title = `${granularity} Lifecycle (Quick Ratio)`;
    const chartSeries = LifecycleCalculations_1.LifecycleCalculations.calculateQuickRatioSeries(data);
    let xAxis = {};
    if (!lodash_1.default.isEmpty(chartSeries)) {
        const xAxisMinTickInterval = 24 * 60 * 60 * 1000; //1 day
        xAxis = {
            dateTimeLabelFormats: DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.xAxis.dateTimeLabelFormats,
            type: "datetime",
            minTickInterval: xAxisMinTickInterval,
        };
    }
    const yAxis = {
        labels: {
            formatter: function () {
                //"{value}"
                return `${this.value}`;
            }
        },
        title: { text: null },
        min: 0,
    };
    const tooltip = {
        useHTML: false,
        formatter: function () {
            const dateCorrected = new Date(this.x);
            const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, dateCorrected.getTime());
            const symbol = "<span style='color:" + this.color + "'>\u25CF</span>";
            const name = this.series.name;
            const value = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(this.point.y, 2);
            //"<small>{date}</small><br/>{symbol} {name}: <b>{value}</b>"
            return `<small>${date}</small><br/>${symbol} ${name}: <b>${value}</b>`;
        }
    };
    return {
        exporting: {
            filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title)
        },
        chart: chart,
        title: { text: title },
        xAxis: xAxis,
        yAxis: yAxis,
        series: chartSeries,
        tooltip: tooltip
    };
};
const optionsFor = (data, params, chartStatus) => {
    if (!data) {
        return {
            options: {},
            chartStatus: chartStatus
        };
    }
    // console.log("Lifecycle calculations with:", JSON.stringify(params));
    switch (params.chartType) {
        case LifecycleChartSettingsJSONModel_1.ChartType.classicWithPercents:
        case LifecycleChartSettingsJSONModel_1.ChartType.classicWithCounters:
            return {
                options: optionsForClassic(data, params),
                chartStatus: chartStatus
            };
        case LifecycleChartSettingsJSONModel_1.ChartType.overtime:
            return {
                options: optionsForOvertime(data, params),
                chartStatus: chartStatus
            };
        case LifecycleChartSettingsJSONModel_1.ChartType.quickRatio:
            return {
                options: optionsForQuickRatio(data, params),
                chartStatus: chartStatus
            };
        default:
            return {
                options: {},
                chartStatus: chartStatus
            };
    }
};
exports.LifecycleHighchartsCalculations = {
    optionsFor: optionsFor
};
